import { X } from 'lucide-react';

interface FilterWrapperProps {
  filterValue: any;
  onClear: () => void;
  children: React.ReactNode;
  className?: string;
  clearButtonInside?: boolean;
}

export function FilterWrapper({
  filterValue,
  onClear,
  children,
  className = '',
  clearButtonInside = true,
}: FilterWrapperProps) {
  const showClear =
    filterValue !== undefined &&
    filterValue !== null &&
    filterValue !== '' &&
    !(Array.isArray(filterValue) && filterValue.length === 0);

  if (!showClear) {
    return <div className={className}>{children}</div>;
  }

  if (clearButtonInside) {
    return (
      <div className={`relative ${className}`}>
        {children}
        <button
          type="button"
          onClick={onClear}
          className="absolute right-2 ml-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          aria-label="Clear filter"
        >
          <X size={16} />
        </button>
      </div>
    );
  } else {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        {children}
        <button
          type="button"
          onClick={onClear}
          className="text-gray-400 hover:text-gray-600 p-1"
          aria-label="Clear filter"
        >
          <X size={16} />
        </button>
      </div>
    );
  }
}
